import { Card, Divider, Grid2, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';

import type { InsurancePlan } from '@models/insurance';

const messages = defineMessages({
  insurance: {
    id: 'profileCard.insurance',
    defaultMessage: 'Insurance',
  },
  insuranceProvider: {
    id: 'profileCard.insuranceProvider',
    defaultMessage: 'Insurance Provider',
  },
  planNumber: {
    id: 'profileCard.planNumber',
    defaultMessage: 'Plan Number',
  },
});

interface InsuranceSectionProps {
  coverage?: InsurancePlan[];
  loading: boolean;
}

export default function InsuranceSection({
  coverage,
  loading,
}: InsuranceSectionProps) {
  const { formatMessage } = useIntl();

  const insuranceContent = (coverage ?? [])
    .sort((a, b) => (a.provider ?? '').localeCompare(b.provider ?? ''))
    .map((i, index) => (
      <Grid2 container key={`${i.planNumber}-${index}`}>
        <Grid2 size={{ xs: 6 }}>
          <Typography color="primary.main" variant="subtitle2">
            {formatMessage(messages.insuranceProvider)}
          </Typography>
          <Typography color="text.primary" variant="body1">
            {i.provider || '- -'}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <Typography color="primary.main" variant="subtitle2">
            {formatMessage(messages.planNumber)}
          </Typography>
          <Typography color="text.primary" variant="body1">
            {i.planNumber || '- -'}
          </Typography>
        </Grid2>
      </Grid2>
    ));

  return (
    <Card sx={{ p: 3 }}>
      <ContentLoader loading={loading}>
        <Typography sx={{ pl: 1 }} variant="body2">
          {formatMessage(messages.insurance).toUpperCase()}
        </Typography>
        <Divider sx={{ my: 0.5 }} />
        {insuranceContent}
      </ContentLoader>
    </Card>
  );
}
